// @import
import { ensureHTMLElement, ensureProps } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";

Alpine.directive("card-objectif", (element, {}, { cleanup, effect }) => {
  const dom = {
    expandBtn: ensureHTMLElement(element.querySelector(".c-cards-objectif__card-expand-btn")),
    description: element.querySelector(".c-cards-objectif__card-description"),
  };

  if (!ensureProps(dom, "description")) return;

  const computeOverflow = () => {
    return dom.description.scrollHeight > dom.description.clientHeight;
  };

  let needExpandBtn = computeOverflow();

  effect(() => {
    if (viewport.width) {
      needExpandBtn = computeOverflow();
      if (!needExpandBtn) {
        dom.expandBtn.style.display = "none";
        element.classList.remove("c-cards-objectif__card--expanded");
      } else {
        dom.expandBtn.style.display = "flex";
      }
    }
  });

  function toggleContent(e: Event) {
    const isExpand = element.classList.contains("c-cards-objectif__card--expanded");
    const icon = dom.expandBtn.querySelector(".c-icon");
    if (isExpand) {
      element.classList.remove("c-cards-objectif__card--expanded");
      icon?.classList.add("c-icon--add");
      icon?.classList.remove("c-icon--supp");
    } else {
      element.classList.add("c-cards-objectif__card--expanded");
      icon?.classList.remove("c-icon--add");
      icon?.classList.add("c-icon--supp");
    }
  }

  dom.expandBtn.addEventListener("click", toggleContent);

  cleanup(() => {
    dom.expandBtn.removeEventListener("click", toggleContent);
  });
});
